import { DraftConfigurationTextStyle, PrintType, StoreFont, TextAlign } from '@/types';
import { getTextSizeForStyle } from '@/utils/text/getTextSizeForStyle';
import { isMultiLine } from '@/utils/text/isMultiLine';
import { isDigital } from '@/model/printType/isDigital';
import { adjustTextStyleOffset } from './adjustTextStyleOffset';

export const getTextStyleForWidth = (
  text: string,
  desiredWidth: number,
  font: StoreFont,
  printType: PrintType,
  textAlign: TextAlign = isMultiLine(text) ? 'center' : 'left'
): DraftConfigurationTextStyle => {
  // Need to measure first with any fontsize and any alignment
  // We then calculate the new font size that lets the text fit into the desiredWidth
  const textStyle: DraftConfigurationTextStyle = {
    font,
    textAlign,
    fontSize: 25,
    angle: 0,
    x: 0,
    y: 0,
  };
  adjustTextStyleOffset(textStyle, text);

  const referenceSize = getTextSizeForStyle(textStyle, text);

  if (referenceSize.width === 0) {
    return textStyle;
  }

  textStyle.fontSize = Math.max(
    (25 * desiredWidth) / referenceSize.width,
    isDigital(printType) ? 1 : font.minimalSize
  );
  adjustTextStyleOffset(textStyle, text);

  return textStyle;
};
